import { HStack, Text, VStack } from '@bpba/ui-components';
import { FC } from 'react';
import { color, ColorProps } from 'styled-system';
import { IoMdCloseCircle } from 'react-icons/io';
import styled from 'styled-components';
import { DEBIN_CONFIRM_ERROR } from '../../constants/data';

const COMPONENT_COLOR = 'red';

type Props = {
  show: boolean | undefined;
  reason?: string | undefined;
};

export const DebinRejected: FC<Props> = ({ show, reason }) => {
  if (!show) return <></>;

  return (
    <StyledVStack alignItems={'center'} my={'48px'} fontWeight={600}>
      <HStack width="50px">
        <StyledCrossIcon color={COMPONENT_COLOR} />
      </HStack>
      <Text color={COMPONENT_COLOR}>{DEBIN_CONFIRM_ERROR}</Text>
      {reason && <Text color={COMPONENT_COLOR} dangerouslySetInnerHTML={{ __html: reason }} />}
    </StyledVStack>
  );
};

const StyledCrossIcon = styled(IoMdCloseCircle)<ColorProps>(color, {
  height: '100%',
  width: '100%',
});

const StyledVStack = styled(VStack)({
  gap: '16px',
});
